module.exports = "/static/media/nucleus-app-icon-n-reversed-vibrant-512.c0b31e56.png";